
<ng-container [ngSwitch]="isHCREnable">
  <div style="position: relative;" [ngClass]="isHcrDemo?'demo-mode':''">
    <ng-container *ngSwitchCase="true">
      <img  src="../../../assets/images/VisionHCR-chip.ico" (click)="showHCRDialog=true"
      style="width: 20px;cursor: pointer;" />
      <ng-container>
        <div class="ver" (click)="showHCRDialog=true"
      style="width: 20px;cursor: pointer;">{{CsHisVer}}</div>
      </ng-container>
    </ng-container>

    <img *ngSwitchDefault src="../../../assets/images/VisionHCR-chip-denied.ico" (click)="showHCRDialog=true"
      style="width: 20px;cursor: pointer;" />
    <div *ngIf="isNoSam" class="no-sam-text" >NoSAM</div>
    
    <mat-slide-toggle color="accent" class="hcr-demo-toggle" [checked]="isHcrDemo" 
    (change)="HcrConsoleComponent.enableDemo($event)" 
    [hidden]="true" 
    aria-label="展示模式切換" 
    style="font-size: 12px; margin-left:6px; vertical-align: middle; width: 66px;">{{ isHcrDemo ? 'ON' : 'OFF' }}</mat-slide-toggle>
    <ng-container *ngIf="isHcrDemo">
      <span >(DEMO)</span>
    </ng-container>

    <ng-container *ngIf="nhiWebApiError">
      <mat-icon style="pointer-events: none;" [class]="CsHisVer?'vpn-error2':'vpn-error'" title="健保WebAPI連線異常">
        warning
      </mat-icon>
    </ng-container>
  </div>

</ng-container>


<app-vis-dialog title="卡機控制軟體設定" [show]="showHCRDialog" (close)="showHCRDialog=false" [width]="600" [height]="HcrConsoleComponent.getRealHeight()>500?555:(HcrConsoleComponent.bigRatio?'95%':HcrConsoleComponent.getRealHeight())">
    <app-hcr-console #hcrConsole></app-hcr-console>
    <app-vis-dialog-actions>
      <ng-container [ngSwitch]="isHCREnable">
        <button type="button" *ngSwitchCase="true" warning="true" (click)="closeHCR()">關閉連線</button>
        <button type="button" *ngSwitchCase="false" primary="true" (click)="openHCR()">開啟連線</button>
        <button [ngClass]="[hcrConsole?.isHcrDemo?'demo-mode':'']" (click)="hcrConsole.enableDemo(null)" [hidden]="!isShowHcrDemo">展示模式</button>
        <!-- <mat-button-toggle class="hcr-toggle" [checked]="false" (change)="hcrConsole.enableDemo($event)" [hidden]="!isShowHcrDemo">展示模式</mat-button-toggle> -->
      </ng-container>

    </app-vis-dialog-actions>
  </app-vis-dialog>
